import { ANALYTICS_CATEGORIES } from 'Services/analytics/analytics.const';

import { basePaymentsEvent } from './base/basePaymentEvent';
import type { PaymentEventProps } from './base/basePaymentEvent.type';

const {
	PAYMENTS: { MOTORWAY_PAY_PAGE },
} = ANALYTICS_CATEGORIES;

export function motorwayPayPageEvents<CustomData extends UnknownShapeObject>(
	props: PaymentEventProps<CustomData>,
): void {
	basePaymentsEvent({
		category: MOTORWAY_PAY_PAGE,
		...props,
	});
}
